"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _utils = require("../utils");

let IS_READY;

class PromoMusictrack {
  constructor(music, videoDuration) {
    this.music = music;
    this.track = this.music.track;
    this.trackDuration = (0, _utils.getMusicDuration)(videoDuration);
    let src = (0, _utils.getMusicSrc)(this.allSrc, this.trackDuration);

    if (!src) {
      src = this.track.url;
    }

    this.audio = this.createAudioElement(src);
    this.videoDuration = videoDuration;
    this.currentTime = this.offset;
    IS_READY = new Promise(resolve => {
      this.audio.oncanplaythrough = () => {
        /*
        ios tweek to load audio and get the oncanplaythrough
        pause audio
        set mute to false
        remove oncanplaythrough
        */
        this.pause();
        this.audio.muted = false;
        this.audio.oncanplaythrough = null;
        resolve();
      };
    });
    this.tweens = [];
  }

  get offset() {
    if (this.isUpload && this.music.start !== undefined) {
      return Number(this.music.start);
    }

    return 0;
  }

  get end() {
    if (this.isUpload && this.music.start !== undefined) {
      return Math.min(this.music.end - this.music.start, this.videoDuration);
    }

    return this.videoDuration;
  }

  createAudioElement(src) {
    const audio = document.createElement('audio');
    document.body.appendChild(audio);
    audio.preload = 'auto';
    /*
    ios tweek to load audio and get the oncanplaythrough
    need to set muted and autoplay
    */

    audio.muted = true;
    audio.autoplay = true;
    audio.src = src;
    return audio;
  }

  get isUpload() {
    return this.track.isUpload;
  }

  get allSrc() {
    return this.track.allDurations;
  }

  get isReady() {
    return IS_READY;
  }

  set currentTime(time) {
    this.audio.currentTime = this.offset + time;
  }

  get currentTime() {
    return this.audio.currentTime;
  }

  get duration() {
    return this.audio.duration || this.trackDuration;
  }

  get fadeOut() {
    if (this.isUpload && this.music.isFadeOut !== undefined) {
      return this.music.isFadeOut;
    }

    return this.duration > this.videoDuration;
  }

  get outDuration() {
    return this.fadeOut ? 0.6 : 0.01;
  }

  get fadeOutTransition() {
    return {
      start: this.end - this.outDuration,
      duration: this.outDuration
    };
  }

  set volume(volume) {
    if (volume === undefined) return;
    this.audio.volume = volume;
  }

  get volume() {
    return this.audio.volume;
  }

  set muted(value) {
    this.audio.muted = value;
  }

  get muted() {
    return this.audio.muted;
  }

  async play() {
    try {
      await this.audio.play();
    } catch (error) {
      throw new Error(error);
    }
  }

  pause() {
    this.audio.pause();
  }

  get paused() {
    return this.audio.paused;
  }

  destroy() {
    return () => {
      // need to clean what we can
      // kill tweens
      this.pause();
      this.tweens.forEach(tween => {
        tween.kill();
      }); // remove all keys

      Object.keys(this).forEach(key => {
        delete this[key];
      });
    };
  }

}

exports.default = PromoMusictrack;